import {isNumber} from "../../../util/numberhelpers";
import {MakeDialog} from "../../../components/Shared/MakeDialog";
import CalendarEntryEditor from "../views/CalendarEntryEditor";
import React, {Component, Fragment} from "react";
import {Button, Col, Row} from "reactstrap";
import {EventClient} from "../../../util/eventClient";
import {hasPermission, RequiredPermission} from "../../../api/permissionHelper";

export class CalendarEntryEditorDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddCalEntry: false,
      editID: null,
      addSelection: {},
      chosenCalendar: 0,
      attachedLead: null,
      showFooter: true,
      scheduleLead: null,
      showReschedule: false,
      showFollowup: false,
      showCancel: false,
      leadId: "",
      followup: false,
    }
    this.calendarEntryEditor = null;
  }

  componentDidMount() {
    EventClient.on("CALENDAR_ENTRY_EDIT", ({eventId, calId, lead, followup}) => this.setState({
      editID: eventId, chosenCalendar: calId, scheduleLead: lead, followup, showCancel: true
    }), "CalendarEntryEditorDialog");
    EventClient.on("CALENDAR_ENTRY_ADD", ({calId, addSelection, lead, followup}) => this.setState({
      showAddCalEntry: true, chosenCalendar: calId, addSelection, attachedLead: lead, followup, showCancel: false
    }), "CalendarEntryEditorDialog");
  }

  componentWillUnmount() {
    EventClient.off("CALENDAR_ENTRY_EDIT", () => {
    }, "CalendarEntryEditorDialog");
    EventClient.off("CALENDAR_ENTRY_ADD", () => {
    }, "CalendarEntryEditorDialog");
  }

  closeMe(cb) {
    this.setState({
      showAddCalEntry: false,
      editID: null,
      addSelection: {},
      chosenCalendar: 0,
      attachedLead: null,
      showFooter: true,
      scheduleLead: null,
      showReschedule: false,
      showFollowup: false,
      showCancel: false,
      leadId: "",
      followup: false,
    }, cb);
  }

  render() {
    if (!this.state.showAddCalEntry && !isNumber(this.state.editID)) return null;
    return (<MakeDialog isOpen={(this.state.showAddCalEntry || isNumber(this.state.editID))}
                        header="Calendar Entry">
      <CalendarEntryEditor
        ref={ref => this.calendarEntryEditor = ref}
        eventName="CalendarEntryEvent"
        saveEvent="CALENDAR_ENTRY_SAVE"
        removeEvent="CALENDAR_ENTRY_REMOVE"
        attachedLead={this.state.attachedLead}
        addSelection={this.state.addSelection}
        calId={this.state.chosenCalendar}
        followup={this.state.followup}
        onSave={() => {
          const calId = this.state.chosenCalendar;
          const leadId = this.state.attachedLead && this.state.attachedLead.id || this.state.scheduleLead && this.state.scheduleLead.id || null;
          this.closeMe(() => {
            if (leadId) {
              EventClient.emit("NAVIGATE", `/calendar/${calId}`);
            } else {
              EventClient.emit("CALENDAR_REFRESH");
            }
          })
        }}
        // onScheduleLead={(cb) => cb(this.state.scheduleLead)}
        scheduleLead={this.state.scheduleLead}
        onDateChange={(same) => {
          this.setState({showReschedule: !same, showCancel: !this.state.showAddCalEntry && same});
        }}
        onFollowup={(leadId) => {
          this.setState({showFollowup: true, leadId: leadId});
        }}
        onClose={() => {
          this.closeMe(() => {
            EventClient.emit("CALENDAR_REFRESH");
          });
        }}
        // templates={this.state.templates['templates'] || []}
        edit={this.state.editID}
        onTabChange={(tab) => this.setState({showFooter: tab !== "4"})}
        footer={(<Row style={{width: "100%", display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
          {this.state.showFooter ? (<Fragment>
              <Col xs={12} lg={6} style={{textAlign: "left"}}>
                <Fragment>
                  {this.state.showReschedule && (<Button color="default"
                                                         onClick={() => this.calendarEntryEditor.showReschedule()}>Reschedule</Button>)}
                  {this.state.showFollowup && (<Button color="default"
                                                       onClick={() => {
                                                         const calId = this.state.chosenCalendar;
                                                         const leadId = this.state.leadId;
                                                         this.closeMe(() => {
                                                           EventClient.emit("NAVIGATE", `/calendar/${calId}/followup/${leadId}`)
                                                         })
                                                       }}>Followup</Button>)}
                  {this.state.showCancel && (<Button color="default"
                                                     onClick={() => this.calendarEntryEditor.showCancel()}>Cancel</Button>)}
                  <Button color="default"
                          onClick={() => this.calendarEntryEditor.showEmail()}>Email</Button>
                  {!this.state.showAddCalEntry && hasPermission(RequiredPermission.CalendarEdit) && (
                    <Button color="default"
                            style={{marginRight: 0}}
                            onClick={() => this.calendarEntryEditor.showTransfer()}>Transfer</Button>)}
                </Fragment>
              </Col>
              <Col xs={12} lg={6} style={{textAlign: "right"}}>
                <Fragment>
                  <Button color="primary"
                          onClick={() => EventClient.emit("CALENDAR_ENTRY_SAVE", null)}>Save</Button>
                  {!this.state.showAddCalEntry && hasPermission(RequiredPermission.CalendarRemove) && (
                    <Button color="danger"
                            onClick={() => EventClient.emit("CALENDAR_ENTRY_REMOVE", null)}>Delete</Button>)}
                  <Button color="secondary"
                          onClick={() => this.closeMe()}>Close</Button>
                </Fragment>
              </Col>

            </Fragment>) :
            <Button color="secondary"
                    onClick={() => this.closeMe()}>Close</Button>
          }
        </Row>)}/>
    </MakeDialog>)
  }
}


// WEBPACK FOOTER //
// ./src/containers/Calendar/modals/CalendarEntryEditorDialog.js